<div class="modal-header">
  <h4 class="modal-title">Reset Avatar</h4>
</div>
<div class="modal-body">
  Are you sure you want to reset your Avatar back to default?
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary mx-1" (click)="resetAvatar()">
    Yes
  </button>
  <button type="button" class="btn btn-secondary mx-1" (click)="this.activeModal.close()">
    No
  </button>
</div>